import { render, staticRenderFns } from "./ContentRightsPreview.vue?vue&type=template&id=6b7fb70c&scoped=true&"
import script from "./ContentRightsPreview.vue?vue&type=script&lang=js&"
export * from "./ContentRightsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContentRightsPreview.vue?vue&type=style&index=0&id=6b7fb70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7fb70c",
  null
  
)

export default component.exports